import styled from "styled-components"

const getNumberFromWidthBreakpoint = (breakpoint: string): number =>
  parseInt(breakpoint.split("px")[0])

interface IGlobalProps {
  marginLeft?: string
  marginRight?: string
  marginTop?: string
  marginBottom?: string
  margin?: string
  alignItems?: string
}

interface IFlexContainer extends IGlobalProps {
  flexDirection?: string
  width?: string
}

export interface IBreakpoints {
  xs: string
  sm: string
  md: string
  lg: string
  xl: string
  xxl: string
  xxxl: string
}

export const WIDTH_BREAKPOINTS: IBreakpoints = {
  xs: "480px",
  sm: "576px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  xxl: "1600px",
  xxxl: "1780px",
}

export const FlexContainer = styled.div<IFlexContainer>`
  display: flex;
  width: 100%;
  align-items: center;
  flex-direction: ${({ flexDirection }) => flexDirection || "row"};
  margin: ${({ margin }) => margin || "0px"};
  margin-left: ${({ marginLeft }) => marginLeft || "0px"};
  margin-right: ${({ marginRight }) => marginRight || "0px"};
  margin-top: ${({ marginTop }) => marginTop || "0px"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "0px"};
`

export const ActionButtons = styled.div<IGlobalProps>`
  display: flex;
  flex-direction: column;
  align-content: space-around;
  ${({ alignItems }) => alignItems && `align-items: ${alignItems}`};
`

export const AuthCardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const ContentClick = styled.div<IGlobalProps>`
  cursor: pointer;
  margin: ${({ margin }) => margin || "0px"};
  margin-left: ${({ marginLeft }) => marginLeft || "0px"};
  margin-right: ${({ marginRight }) => marginRight || "0px"};
  margin-top: ${({ marginTop }) => marginTop || "0px"};
  margin-bottom: ${({ marginBottom }) => marginBottom || "0px"};
`

export const colors = {
  blue5: "#40A9FF",
  blue6: "#177DDC",
  gray1: "#FFFFFF",
  gray3: "#F5F5F5",
  gray4: "#E8E8E8",
  gray5: "#D9D9D9",
  gray7: "#8C8C8C",
  gray8: "#595959",
  gray9: "#262626",
  gray10: "#141414",
  red6: "#F5222D",
  volcano6: "#FA541C",
}

export const playerVideoScale = 9 / 16
export const liveContainerHeight = `${window.innerWidth * playerVideoScale}px`
export const formChatHeight = "64px"
export const momentsHeight =
  window.innerWidth > getNumberFromWidthBreakpoint(WIDTH_BREAKPOINTS.xl) ? "185px" : "140px"
